module.exports = __webpack_public_path__ + "img/logo_espace_client_ubiflow_es.9daaa3fa.png";